import { stringify } from '../libs/queryString';
import { Template } from '../web-api/domain/template';

export function getEditorLink({
  template,
  editorSessionId,
  petri_ovr,
  dashboardFirstMetaSiteId,
  siteCreationFolderId,
  dashboardFirst,
}: {
  template: Template;
  editorSessionId: string;
  petri_ovr?: string;
  dashboardFirstMetaSiteId?: string;
  siteCreationFolderId?: string;
  dashboardFirst?: string;
}): string {
  const { metaSiteId } = template;

  return `https://manage.wix.com/edit-template/from${dashboardFirstMetaSiteId ? '-intro-siteless' : ''}?${stringify({
    originTemplateId: metaSiteId,
    editorSessionId,
    petri_ovr,
    siteCreationFolderId,
    metaSiteId: dashboardFirstMetaSiteId,
    dashboardFirst,
  })}`;
}

export function getViewerLink({
  templateSlug,
  language,
  originUrl,
  clickedElement = 'view_button',
  editorSessionId,
  dashboardFirstMetaSiteId,
  dashboardFirst,
}: {
  templateSlug: string;
  language: string;
  originUrl: string;
  clickedElement?: 'view_button' | 'thumbnail';
  editorSessionId: string;
  dashboardFirstMetaSiteId?: string;
  dashboardFirst?: string;
}): string {
  return `https://${
    language === 'en' ? 'www' : language
  }.wix.com/website-template/view/html/${templateSlug}?${stringify({
    originUrl,
    tpClick: clickedElement,
    esi: editorSessionId,
    ...(dashboardFirstMetaSiteId ? { dashboardFirstMetaSiteId } : null),
    ...(dashboardFirst ? { dashboardFirst } : null),
  })}`;
}
